import type { FieldCodec, OptionRef } from 'v5/core/entity-values/values.types';
import { splitOptionRefs } from './optionRefs';
import { validateField, validation } from './validation';

function isEmpty(value: OptionRef[]): boolean {
  return value.length === 0;
}

/** Resource tags: existing ids plus labels to create when `allowCreate`. */
export const tagsCodec: FieldCodec<'tags'> = {
  decode(entity) {
    return (entity.tags ?? []).map(tag => ({ type: 'existing', id: tag.id }));
  },
  encode(value) {
    const { ids, create } = splitOptionRefs(value);
    return { type: 'tags', ids, create };
  },
  empty() {
    return [];
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, (value, spec) => {
      const created = value.filter(ref => ref.type === 'new');
      if (created.length > 0 && !spec.allowCreate) {
        return validation.invalid({ code: 'tags-not-allowed' });
      }
      if (created.some(ref => ref.label.trim() === '')) {
        return validation.invalid({ code: 'part-required', part: 'tag-name' });
      }
      return validation.valid();
    });
  }
};
